// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"cf37f0e1","787":"b2ce8df3","964":"f7d11455"}[chunkId] + ".chunk.js";
};